// Hallazgo del 10-oct (celular): al pasar de un campo al siguiente con "siguiente" del teclado, el campo con foco
// quedaba DEBAJO de la barra Atrás/Siguiente o de la navegación de abajo. Si al enfocarse queda tapado por algo fijo,
// se centra en la pantalla. (El CSS además deja scroll-padding abajo; esto cubre lo que el navegador no hace solo.)
export function instalarFocoVisible(win: Window = window): () => void {
  const alEnfocar = (ev: FocusEvent) => {
    const el = ev.target;
    if (!(el instanceof HTMLElement) || !el.matches('input, textarea, select, [contenteditable="true"]')) return;
    win.setTimeout(() => {
      const r = el.getBoundingClientRect();
      const x = r.left + r.width / 2;
      const y = Math.min(r.top + r.height / 2, win.innerHeight - 1);
      const encima = win.document.elementFromPoint(x, y);
      const tapado = r.bottom > win.innerHeight || r.top < 0 || (encima !== null && encima !== el && !el.contains(encima) && !encima.contains(el));
      if (tapado && typeof el.scrollIntoView === 'function') el.scrollIntoView({ block: 'center', behavior: 'smooth' });
    }, 250); // después de que el teclado del teléfono termine de subir
  };
  win.document.addEventListener('focusin', alEnfocar);
  return () => win.document.removeEventListener('focusin', alEnfocar);
}
